import React from 'react';
import StoreButtons from './ui/StoreButtons';
import { GradientOrbs, GridOverlay } from './ui/BackgroundGraphics';

function HomeCTA() {
  return (
    <section className="relative overflow-hidden py-24 md:py-28">
      <GradientOrbs />
      <GridOverlay />

      <div className="site-container relative">
        <div className="overflow-hidden rounded-[2rem] border border-primary/20 bg-gradient-to-br from-primary/15 via-charcoal to-charcoal p-10 text-center md:p-16">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl border border-primary/30 bg-primary/15 text-3xl">
            🏳️‍🌈
          </div>
          <h2 className="text-3xl font-black text-white md:text-4xl lg:text-5xl">
            Connection shouldn&apos;t cost <span className="text-primary">your privacy.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-silver md:text-lg">
            Join queer people who wanted dating and hookups on an app that protects them by design. Free
            to download on iOS and Android.
          </p>
          <div className="mt-8 flex justify-center">
            <StoreButtons size="lg" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeCTA;
